import { render, staticRenderFns } from "./_icon-container.svg.vue?vue&type=template&id=9134a9d0&"
import script from "./_icon-container.svg.vue?vue&type=script&lang=js&"
export * from "./_icon-container.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports